// extracted by css-extract-rspack-plugin
export default {"muiTooltip":"muiTooltip-rKFjsY","tooltipContent":"tooltipContent-rS9oWC"};